module.exports = __webpack_public_path__ + "static/media/red-close.e216f612.svg";